require('normalize.css/normalize.css');
require('animate.css/animate.min.css');
require('styles/App.css');

import React from 'react';
import bindKeyboard from 'react-swipeable-views/lib/bindKeyboard';
import autoPlay from 'react-swipeable-views/lib/autoPlay';
import SwipeableViews from 'react-swipeable-views';
import ReactPlayer from 'react-player';
import * as MagazineActions from '../actions/MagazineActions';
import MagazineStore from '../stores/MagazineStore';

const BindKeyboardSwipeableViews = bindKeyboard(SwipeableViews);
const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

class AppComponent extends React.Component {
  constructor(props) {
    super(props);
    this.maps = [];
    this.state = {
      images: false,
      video: false,
      hideVideoPlayer: false,
      showVideo: false,
      loading: true,
      slides: MagazineActions.getCampoArticles(true),
      currentIndex: 0,
      displayNav: false,
      longBasic: false,
      galleryIndex: 0,
      fixWidth: false
    };
  }

  componentWillMount() {
    MagazineStore.on('CAMPO_ARTICLES_RECEIVED', this._onReceiveArticles.bind(this));
    MagazineStore.on('NO_NETWORK_CONNECTION', this._onNetworkError.bind(this));
  }

  _onReceiveArticles() {
    this.setState({
      slides: MagazineStore.getCampoArticles(),
      loading: false
    });
  }

  _onNetworkError() {
    this.setState({
      errorType: 'NETWORK',
      loading: false
    });
  }

  handleGalleryClick(images, fixWidth) {
    images = images.split(',');
    let keyId = 0;
    let className = 'slide ' + fixWidth;
    images = images.map((image) => {
      keyId++;
      return <div key={keyId} className={className}><img src={image} /></div>
    });
    this.setState({
      galleryIndex: 0,
      images: images,
      fixWidth: fixWidth
    });
  }

  handleGalleryIndex(index) {
    this.setState({
      galleryIndex: index
    });
  }

  handleLinkClick(linkTo) {
    if (linkTo.charAt(0) === 'h') {
      var link = document.createElement('a');
      link.href = linkTo;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      this.handleSwipeEvent(parseInt(linkTo));
    }
  }

  handleVideoClick(video) {
    this.setState({
      video: video
    });
  }

  handleCloseGallery() {
    this.setState({
      images: []
    });
  }

  handleCloseVideo() {
    this.setState({
      video: false
    });
  }

  handleSwipeEvent(index) {
    let slideVideo = 'showVideo' + index;
    this.setState({
      [slideVideo]: true,
      displayNav: index > 1,
      currentIndex: index
    });
  }

  handleEndVideo() {
    this.setState({
      video: false
    });
  }

  handleHomeClick() {
    this.setState({
      currentIndex: 1,
      displayNav: false
    });
  }

  handleLongBasicClick(text) {
    this.setState({
      longBasic: text
    });
  }

  handleCloseBasic() {
    this.setState({
      longBasic: false
    });
  }

  render() {

    let { images } = this.state;
    let { video } = this.state;
    let { slides } = this.state;
    let { loading } = this.state;
    let { currentIndex } = this.state;
    let { longBasic } = this.state;
    let { galleryIndex } = this.state;
    let { fixWidth } = this.state;
    let galleryHandler = '';
    if (images) {
      galleryHandler = images.map((elem, index) => {
        return <li className={index === galleryIndex ? 'active' : ''} key={index} onClick={this.handleGalleryIndex.bind(this, index)}><i className="fa fa-circle"></i></li>
      });
    }

    let handlerClasses = 'gallery-handler ' + fixWidth;

    let galleryBody =
      <div className="image-gallery-container">
        <i className="close-gallery-button fa fa-times-circle fa-lg fa-fw" onClick={this.handleCloseGallery.bind(this)}></i>
        <SwipeableViews children={images} index={galleryIndex}>
        </SwipeableViews>
        <ul className={handlerClasses}>{galleryHandler}</ul>
      </div>;
    let videoBody =
      <div className="image-gallery-container">
        <i className="close-gallery-button fa fa-times-circle fa-lg fa-fw" onClick={this.handleCloseVideo.bind(this)}></i>
        <ReactPlayer url={video || ''} playing onEnded={this.handleEndVideo.bind(this)} width="100%" height="100%"></ReactPlayer>
      </div>;

    let longBasicBody =
      <div className="image-gallery-container darkblue padding">
        <i className="close-gallery-button fa fa-times-circle fa-lg fa-fw" onClick={this.handleCloseBasic.bind(this)}></i>
        <p>{longBasic}</p>
      </div>;

    let articles = [];

    if (slides) {
      let i = 0;
      articles = slides.map((article) => {
        i++;
        return <SlideComponent key={i} video={article.video} imageSrc={article.imageSrc} maps={article.maps}
          galleryClick={this.handleGalleryClick.bind(this)} longBasicClick={this.handleLongBasicClick.bind(this)}
          linkClick={this.handleLinkClick.bind(this)} videoClick={this.handleVideoClick.bind(this)}
          showVideo={this.state['showVideo' + i]} />
      });
    }

    articles.unshift(<CoverComponent imageSrc="" video="http://www.wblocks.com/revista/images/cover.webm" />);

    let body = loading ? 'Loading' : articles;
    let header = this.state.displayNav ? <NavBarComponent homeClicked={this.handleHomeClick.bind(this)} /> : '';

    return (
      <div className="index">
        {images.length > 0 ? galleryBody : ''}
        {video ? videoBody : ''}
        {longBasic ? longBasicBody : ''}
        {header}
        <BindKeyboardSwipeableViews children={body} index={currentIndex} onChangeIndex={this.handleSwipeEvent.bind(this)}>

        </BindKeyboardSwipeableViews>
      </div>
    );
  }
}

class NavBarComponent extends React.Component {
  constructor(props) {
    super(props);
  }

  handleHomeClicked() {
    this.props.homeClicked();
  }

  render() {
    return (
      <div className="navbar">
        <div onClick={this.handleHomeClicked.bind(this)} className="home-button">
          <i className="fa fa-bars fa-lg"></i>
        </div>
      </div>
    );
  }
}

class CoverComponent extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    setTimeout(() => {
      var video = document.getElementById('video');
      video.play();
      video.addEventListener('click', () => {
        video.play();
      }, false);
    }, 200);
  }

  render() {
    let video = this.props.video;
    let image = this.props.imageSrc;
    let body = video ? <ReactPlayer url="http://www.wblocks.com/revista/images/cover.webm" playing width="100%" height="100%">
    </ReactPlayer> : <img src={image} />
    body = <video id="video" width="100%" height="100%">
      <source src="http://www.wblocks.com/revista/campo/covers/cover1.webm" />
    </video>

    return (
      <div className="slide">
        <div className="image-container cover">
          {body}
        </div>
      </div>
    );
  }
}


class SlideComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      videoEnded: false
    };
  }

  handleEndVideo() {
    /*this.setState({
      videoEnded: true
    });*/
  }

  render() {
    let image = this.props.imageSrc;
    let i = 0;
    let maps = this.props.maps.map((elem) => {
      i++;
      switch (elem.type) {
        case 'Basic': {
          return <MapBasicComponent key={i} text={elem.text} top={elem.top + '%'} left={elem.left + '%'}
            color={elem.color} animation={elem.animation} image={elem.images} imageWidth={elem.imageWidth + '%'} />;
        }
        case 'Link': {
          return <MapLinkComponent key={i} shape="square" top={elem.top + '%'} left={elem.left + '%'} linkTo={elem.linkTo}
            size={elem.color} image={elem.images} text={elem.text} imageWidth={elem.imageWidth + '%'} onLinkClick={this.props.linkClick} longBasic={this.props.longBasicClick} />;
        }
        case 'Audio': {
          return <MapAudioComponent key={i} paramId={elem.id} source={elem.audio}
            top={elem.top + '%'} left={elem.left + '%'} color={elem.color} />;
        }
        case 'Gallery': {
          return <MapImageGalleryComponent key={i} images={elem.images} onGalleryClick={this.props.galleryClick}
            top={elem.top + '%'} left={elem.left + '%'} color={elem.color} />;
        }
        case 'Video': {
          return <MapVideoComponent key={i} shape="square" video={elem.video} onVideoClick={this.props.videoClick}
            top={elem.top + '%'} left={elem.left + '%'} color={elem.color} />;
        }
        case 'Slideshow': {
          return <MapSlideshowComponent key={i} images={elem.images}
            top={elem.top + '%'} left={elem.left + '%'} color={elem.color} />;
        }
      }
    });

    let animationsMaps = this.props.maps.map((elem) => {
      i++;
      switch (elem.type) {
        case 'Animation': {
          return <MapAnimationComponent key={i} images={elem.images} animation={elem.animation}
            top={elem.top + '%'} left={elem.left + '%'} color={elem.color} imageWidth={elem.imageWidth + '%'} />;
        }
      }
    });

    return (
      <div className="slide">
        <div className="image-container">
          {(this.props.showVideo && !this.state.videoEnded) ?
            <ReactPlayer width="100%" height="100%" playing url={this.props.video} onEnded={this.handleEndVideo.bind(this)}></ReactPlayer> : ''}
          {(this.props.showVideo) ?
            animationsMaps : ''}
          {maps}
          <img src={image} className="article-background" />
        </div>
      </div>
    );
  }
}

class MapBasicComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      display: false
    }
  }

  handleClickToShow() {

    this.setState({
      display: !this.state.display
    })
  }

  render() {
    let animationClasses = 'map-data-container animated ' + this.props.animation;
    let content = !this.props.image ?
      <div className={animationClasses}>
        <div className="map-data-content">
          <p>{this.props.text}</p>
        </div>
      </div> : <div className={animationClasses}><img style={{ width: this.props.imageWidth }} src={this.props.image} /></div>;
    let {display} = this.state;
    let classes = this.props.image ? 'image-map circle ' : 'image-map circle ' + this.props.color;
    let body = display ? content : '';
    let color = this.props.image ? 'map-container ' : 'map-container ' + this.props.color;

    return (
      <div className={color} onClick={this.handleClickToShow.bind(this)} style={{ top: this.props.top }}>
        {body}
        <div className={classes} style={{ top: this.props.top, left: this.props.left }}>
          <i className="fa fa-plus fa-lg fa-fw"></i>
        </div>
      </div>
    );
  }
}

class MapAnimationComponent extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    let animationClasses = 'map-data-container animated ' + this.props.animation;
    let content =
      <div className={animationClasses} style={{ top: this.props.top, left: this.props.left }}>
        <img style={{ width: this.props.imageWidth }} src={this.props.images} />
      </div>;

    return (
      <div style={{ top: this.props.top }}>
        {content}
      </div>
    );
  }
}

class MapLinkComponent extends React.Component {
  constructor(props) {
    super(props);
  }

  handleClickLink() {
    if (this.props.text && this.props.text.length > 190) {
      this.props.longBasic(this.props.text);
    } else {
      this.props.onLinkClick(this.props.linkTo);
    }
  }

  render() {
    let animationClasses = 'image-map circle square ' + this.props.animation;
    let size = this.props.size.toString().split(',');

    return (
      <div style={{ top: this.props.top }} onClick={this.handleClickLink.bind(this)} >
        <div className={animationClasses}
          style={{ top: this.props.top, left: this.props.left, width: size[1] + 'px', height: size[0] + 'px' }}>

        </div>
      </div>
    );
  }
}

class MapAudioComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      playing: false
    }
  }

  handlePlayClick() {
    //this.stopAllMedia();
    this.setState({
      playing: !this.state.playing
    });
  }

  stopAllMedia() {
    let media = document.getElementsByClassName('media'),
      i = media.length;

    while (i--) {
      media[i].pause();
      media[i].currentTime = 0;
    }
  }

  render() {
    let {playing} = this.state;
    let color = 'image-map circle ' + this.props.shape + ' ' + this.props.color;

    if (document.getElementById(this.props.paramId)) {
      if (playing) {
        document.getElementById(this.props.paramId).play()
      } else {
        document.getElementById(this.props.paramId).pause()
      }
    }
    return (
      <div className={color} style={{ top: this.props.top, left: this.props.left }} onClick={this.handlePlayClick.bind(this)}>
        <audio className="media" id={this.props.paramId} src={this.props.source}></audio>
        <i className="fa fa-volume-up fa-lg fa-fw"></i>
      </div>
    );
  }
}

class MapImageGalleryComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      display: false
    }
  }

  handleClickToShow() {
    this.props.onGalleryClick(this.props.images, this.props.color);
  }

  render() {
    let color = 'image-map circle ' + this.props.color;

    return (
      <div className={color} style={{ top: this.props.top, left: this.props.left }} onClick={this.handleClickToShow.bind(this)}>
        <i className="fa fa-picture-o fa-lg fa-fw"></i>
      </div>
    );
  }
}

class MapVideoComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      display: false
    }
  }

  handleVideoClick() {
    this.props.onVideoClick(this.props.video);
  }

  render() {
    let color = 'image-map circle ' + this.props.shape + ' ' + this.props.color;

    return (
      <div className={color} style={{ top: this.props.top, left: this.props.left }} onClick={this.handleVideoClick.bind(this)}>
        <i className="fa fa-play-circle-o fa-lg fa-fw"></i>
      </div>
    );
  }
}

class MapSlideshowComponent extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    let color = 'image-map slideshow-component ' + this.props.color;

    let images = this.props.images.split(',');
    let keyId = 0;
    images = images.map((image) => {
      keyId++;
      return <div key={keyId} className="slide"><img src={image} /></div>
    });

    return (
      <AutoPlaySwipeableViews className={color} style={{ top: this.props.top, left: this.props.left, 'overflow': 'hidden' }}>
        {images}
      </AutoPlaySwipeableViews>
    );
  }
}

class SocialActions extends React.Component {
  constructor(props) {
    super(props);
  }

  handleFacebookClick() {
    alert('Facebook share');
  }

  handleTwitterClick() {
    alert('Twitter share');
  }

  handleInstagramClick() {
    alert('instagram share');
  }

  render() {
    return (
      <div className="image-map social-actions-container" style={{ top: this.props.top }}>
        <div className="image-map map-facebook" onClick={this.handleFacebookClick.bind(this)}>
        </div>
        <div className="image-map map-twitter" onClick={this.handleTwitterClick.bind(this)}>
        </div>
        <div className="image-map map-instagram" onClick={this.handleInstagramClick.bind(this)}>
        </div>
      </div>
    );
  }
}

AppComponent.defaultProps = {
};

export default AppComponent;



// WEBPACK FOOTER //
// ./src/components/Main.js